export default {
    USER_ID: 'user_OLZL3TsYalVpfsOcMUPIq',
    TEMPLATE_ID: 'template_9cofbqs'
    }